import { Pipe, PipeTransform } from '@angular/core';
import { UrlSasDTO } from '../models/AzureStorage/UrlSasDTO';
import { ImageCacheService } from '../services/ImageCache.service';
import { CallBackService } from '../../pages/callback/services/CallBack.service';
import { LocalStorageService } from '../services/LocalStorage.service';

@Pipe({
  name: 'findUrl'
})
export class FindUrlPipe implements PipeTransform {
  constructor(
    private imageCache: ImageCacheService, 
    private callbackService: CallBackService,
    private localStorageService: LocalStorageService,
  ) {}

  transform(icon: string): string {
    const img = this.imageCache.getMapixImage(icon);
    
    if (img) 
      return img;

    // en caso de que no la encuentra, la vuelve a buscar como antes
    const urlList = JSON.parse(this.localStorageService.getUrlList() || '[]');
    var foundUrl = urlList.find((url: any) => url.name === icon);
    return foundUrl ? foundUrl.url : '';
  }
}